var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-custom-scrollbar",
    {
      class: [
        "go-modal-detail modal fade",
        { show: _vm.isShowDetailTopic, "d-block": _vm.isShowDetailTopic },
      ],
      attrs: { id: "go-detail-report", tabindex: "-1" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "go-detail-container" },
                  [
                    _c("div", { staticClass: "go-detail-toolbar" }, [
                      _c("div", { staticClass: "go-fixed-box" }, [
                        _c("div", { staticClass: "go-btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-icon",
                              attrs: {
                                type: "button",
                                "data-dismiss": "modal",
                                disabled: _vm.updatingBookmark,
                              },
                              on: { click: _vm.handleClosePopup },
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      value: {
                                        placement: "topright",
                                        customClass: "go-tooltip",
                                      },
                                      expression:
                                        "{ placement: 'topright', customClass: 'go-tooltip' }",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  staticClass: "go-tooltip-area",
                                  attrs: { title: _vm.$t("topic.close") },
                                },
                                [
                                  _c("i", {
                                    staticClass: "go-icon-24 go-icon-close",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-btn-group" }, [
                          this.getSelectedResource.originParentDocDetail &&
                          !this.getSelectedResource.isGroupChildren
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  class: [
                                    {
                                      active:
                                        this.getSelectedResource.isBookmarked,
                                    },
                                  ],
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "button",
                                    disabled: _vm.updatingBookmark,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.addToResource.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass:
                                        "go-tooltip-area go-toggle-off",
                                      attrs: {
                                        title: _vm.$t(
                                          "briefing.label.add-to-scrape"
                                        ),
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-20 go-icon-bookmark",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass:
                                        "go-tooltip-area go-toggle-on",
                                      attrs: {
                                        title: _vm.$t(
                                          "briefing.label.remove-to-scrape"
                                        ),
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-20 go-icon-bookmark-on",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkToShow(
                            "hideButton",
                            this.getSelectedResource
                          )
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.updatingBookmark,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.callHideFunction.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "go-tooltip-area",
                                      attrs: {
                                        title: _vm.$t("common.label.hidden"),
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-24 go-icon-hidden",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-icon",
                              attrs: {
                                type: "button",
                                disabled: _vm.updatingBookmark,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.shareTopic.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      value: {
                                        placement: "topright",
                                        customClass: "go-tooltip",
                                      },
                                      expression:
                                        "{ placement: 'topright', customClass: 'go-tooltip' }",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  staticClass: "go-tooltip-area",
                                  attrs: { title: _vm.$t("report.share") },
                                },
                                [
                                  _c("i", {
                                    staticClass: "go-icon-24 go-icon-share",
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "go-dropdown-group dropdown" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn go-btn-icon dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                    disabled: _vm.updatingBookmark,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "go-tooltip-area",
                                      attrs: {
                                        title: _vm.$t("report.download"),
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-24 go-icon-download",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dropdown-menu",
                                  staticStyle: { "margin-left": "-45px" },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.updatingBookmark,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.downloadTopicPDF.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "go-icon-20" }, [
                                        _c("img", {
                                          attrs: {
                                            src: "content/images/images_v3/common/go-icon-document/file-pdf-fill.svg",
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "go-text",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t("report.downloadPDF")
                                            ),
                                          },
                                        },
                                        [_vm._v("PDF")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.updatingBookmark,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.downloadAsWord.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "go-icon-20" }, [
                                        _c("img", {
                                          attrs: {
                                            src: "content/images/images_v3/common/go-icon-document/file-word-fill.svg",
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "go-text",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t("report.downloadWord")
                                            ),
                                          },
                                        },
                                        [_vm._v("Word")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-icon",
                              attrs: {
                                type: "button",
                                disabled: _vm.updatingBookmark,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.printTopics.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      value: {
                                        placement: "topright",
                                        customClass: "go-tooltip",
                                      },
                                      expression:
                                        "{ placement: 'topright', customClass: 'go-tooltip' }",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  staticClass: "go-tooltip-area",
                                  attrs: { title: _vm.$t("report.print") },
                                },
                                [
                                  _c("i", {
                                    staticClass: "go-icon-24 go-icon-print",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("topic-content", {
                      ref: "topicContent",
                      attrs: {
                        loading: _vm.loading,
                        topicDetail: _vm.topicDetail,
                        detailSocialBP: _vm.detailSocialBP,
                        briefingPageId: _vm.briefingPageId,
                        viewCount: _vm.items.countView,
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-detail-aside" }, [
                      _c("div", { staticClass: "go-fixed-box" }, [
                        _c("div", { staticClass: "go-panel go-panel-aside" }, [
                          _c("div", { staticClass: "go-panel-header" }, [
                            _c("ul", { staticClass: "nav go-tab-line" }, [
                              _c("li", { staticClass: "go-tab-item" }, [
                                _c(
                                  "a",
                                  {
                                    class: [
                                      "go-tab-link",
                                      { active: !_vm.isShowTopicRef },
                                    ],
                                    attrs: {
                                      href: "#",
                                      "data-toggle": "tab",
                                      "data-target": "#home",
                                      role: "tab",
                                      "aria-selected": "true",
                                    },
                                  },
                                  [_vm._v("Ask Goover")]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "go-tab-item" }, [
                                _c(
                                  "a",
                                  {
                                    class: [
                                      "go-tab-link",
                                      { active: _vm.isShowTopicRef },
                                    ],
                                    attrs: {
                                      href: "#",
                                      "data-toggle": "tab",
                                      "data-target": "#profile",
                                      role: "tab",
                                      "aria-selected": "false",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("report.reportReference"))
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "go-panel-body tab-content" },
                            [
                              _c(
                                "div",
                                {
                                  class: [
                                    "tab-pane fade",
                                    _vm.isShowTopicRef ? "" : "show active",
                                  ],
                                  attrs: { id: "home" },
                                },
                                [
                                  _c("ask-goover", {
                                    ref: "askGoover",
                                    attrs: {
                                      "reference-documents": [
                                        _vm.getSelectedResource.docId,
                                      ].concat(_vm.contentReference),
                                      "full-size": false,
                                      page: _vm.PAGES.REPORT_DETAIL,
                                      docId: _vm.getSelectedResource.docId,
                                      targetBpId: _vm.conversationId,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: [
                                    "tab-pane fade",
                                    _vm.isShowTopicRef ? "show active" : "",
                                  ],
                                  attrs: { id: "profile" },
                                },
                                [
                                  _c("reportReferent", {
                                    attrs: {
                                      items: _vm.contentReference,
                                      showEditReference: false,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }